import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Thankyou() {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
        navigate("/"); // redirect 
        }, 3000);

        return () => clearTimeout(timer); 
    }, [navigate]);

  return (
    <>
    <div className="thankyou-page">
        <div className="thankpage-box">
            <div className="thankbox">
                <img src="/image/thankyou.webp" className="img-responsive" alt="Thankyou"/>
                <p>I hope these ideas inspire you to reimagine your spaces… Share your transformations and remember, a well-designed home always reflects your story.</p>
            </div>
        </div>
    </div>
    </>
  )
}
